module.exports = __webpack_public_path__ + "img/app-ubbimed.3bc4d4e8.png";